import { type GetFundStructureV2200 } from "@vega-api/generated/types/getFundStructureV2200";

export const getGetFundStructureV2ResponseMock = (
  overrideResponse: Partial<GetFundStructureV2200> = {},
): GetFundStructureV2200 => ({
  ...{
    data: {
      id: "5fb9220d-9b0f-4d32-a248-6492457c3890",
      name: {
        attribute: undefined,
        footnotes: undefined,
        displayNumber: 4253333921996283,
      },
      code: "LNDOzBwbfbH",
      fundType: "OPEN_ENDED",
      currency: {
        attribute: "NOK",
        footnotes: undefined,
        displayNumber: 6269279065888341,
      },
      summary: {
        attribute: "fFZhATMKKspQQTVA",
        footnotes: undefined,
        displayNumber: 1763529763359044,
      },
      reportingDataStatus: "POST_REPORTING",
      openEndedFundType: "PUBLIC",
      attributes: {
        name: {
          attribute: "dqRbQogKGTMPojNPZ",
          footnotes: [
            "rWSwNNfUAQqUuaVeqX",
            "DGxprINPPezcCwUsghNG",
            "eKdQKeeZttQ",
            "ZNteODwVfzaycggHMEYt",
          ],
          displayNumber: 7823645420096782,
        },
        currency: {
          attribute: "ISK",
          footnotes: ["cUBZdCYBGKxGEUcoXUxG"],
          displayNumber: 1694444769664874,
        },
        summary: {
          attribute: "EeYZKBqQJiVQX",
          footnotes: undefined,
          displayNumber: 4489568202725266,
        },
        priorVintageCodes: [
          "MwgosHDsZFmfhmij",
          "jUeBvZfuYTQni",
          "WCDoOjqwAmfFpEizB",
          "rgdZqQnJNE",
          "vsWRYgMWjdMDRhP",
          "iiQIBsTuQwty",
        ],
        assetClass: undefined,
        impactFocusedStrategy: undefined,
        investmentType: undefined,
        industries: undefined,
        investmentStrategies: undefined,
        geographicalFocusRegions: undefined,
        vintageYear: undefined,
        hardCap: {
          attribute: {
            amount: 0.69,
            currency: "SAR",
          },
          footnotes: [
            "dErGcTYYMgNbbqzOJ",
            "oZwxiPKleJIoXh",
            "XvHuoZvUllbHtS",
            "YjTOORNGgbVGPzg",
          ],
          displayNumber: 6175023144205085,
        },
        productTermYears: undefined,
        termExtension: undefined,
        additionalFootnotes: {
          characteristicsFootnotes: undefined,
          compositionsFootnotes: {
            displayNumber: undefined,
            footnote: "mGKiibMIyRPETk",
          },
          fundManagerTeamFootnotes: undefined,
        },
        globalFootnotes: undefined,
        proposedLaunchDate: {
          attribute: {
            proposedLaunchDate: undefined,
            additionalInformation: undefined,
          },
          footnotes: undefined,
          displayNumber: 3876945449463318,
        },
      },
      loanEligible: true,
      employeeFund: false,
      isSma: false,
      oppName: "xFGEKmAftzHXFMAGdns",
      termsAndConditions: {
        header: "hoYrzkFokA",
        body: "lbfrPDApWu",
        url: undefined,
      },
      isDummy: undefined,
      fundVehicles: [
        {
          fundVehicleId: "a0409a16-7516-4c11-a5fa-a590ae9db1e1",
          name: {
            attribute: undefined,
            footnotes: [
              "IopPxPQSVwqEtF",
              "JtiwhUribHHrdvqJF",
              "lZxJhzbAYtcbui",
              "NxpUgXqUFQ",
              "oXuurCiCCNRwpnkcroYD",
              "EhxGzuZTGDGku",
              "yClYVLBTgP",
            ],
            displayNumber: 7153613687822354,
          },
          code: "TXhyZzSEtokNu",
          currency: {
            attribute: "NOK",
            footnotes: undefined,
            displayNumber: 1107171043465696,
          },
          carryProduct: false,
          fundingStatus: {
            attribute: "UPCOMING",
            footnotes: undefined,
            displayNumber: 6652694474443120,
          },
          isEmployee: true,
          attributes: {
            legalName: "uLkUotdfAnRatrbgv",
            description: {
              attribute: undefined,
              footnotes: [
                "napOAstapHY",
                "bUOOxupdlmzMydXXOZC",
                "dtlkhGOEhQHuJnrVpyUK",
                "haGxgXBmAJ",
                "oPxCwcixkc",
                "ZPSmXkXZLZDnwEdGZjP",
                "XXBYNiyLmHIiDOzaasW",
                "GlqSLewbzIgp",
                "VZcNtuNVXEsOnD",
              ],
              displayNumber: 5914406917741359,
            },
            legalEntityIdentifier: undefined,
            jurisdictionState: undefined,
            jurisdictionCountry: "CY",
            currency: {
              attribute: "HRK",
              footnotes: undefined,
              displayNumber: 3807601063188702,
            },
            closingSchedule: {
              attribute: [
                "2025-01-01T10:00:00Z",
                "2025-01-01T10:00:00Z",
                "2025-01-01T10:00:00Z",
                "2025-01-01T10:00:00Z",
              ],
              footnotes: [
                "noIYFedXpeFGHna",
                "nJKFqoFTXfiXMTkEKJva",
                "nxXuRjIYfaweMVwn",
              ],
              displayNumber: 6516238645782526,
            },
            subscriptionDeadline: undefined,
            investorTaxDocumentations: [
              "FORM_K1",
              "FORM_1099",
              "NOT_APPLICABLE",
            ],
            footnotes: {
              cSJ0f: ["mdxMFIeXRPQW", "kGMMBdtVEBntUIO", "GmKwxHWdQpxbpA"],
            },
            globalFootnotes: [
              {
                displayNumber: 8350670165316079,
                footnotes: ["vIniidjITQJfpqmABs", "RPqVXqsAWTfuC"],
              },
              {
                displayNumber: 4531814431802224,
                footnotes: ["JRSMwFiJjKlgiaLMAie", "iUmsflAFmd"],
              },
              {
                displayNumber: 3522110967383537,
                footnotes: [
                  "XGCvwCKKiAvT",
                  "BgFgrhJkuUkAvaPd",
                  "DGJnaLBRQRzrPxj",
                ],
              },
              {
                displayNumber: 7700921351817022,
                footnotes: [
                  "duPUkdTuCYdHdtP",
                  "ZDqlstdtyLIKal",
                  "zaPOCdNEONPAhIGMi",
                  "UMVNFIUEGiyL",
                  "kqmlwVAjeKtQ",
                  "PoKnWHqojKlEnIQON",
                  "eKtwbnbTmCcI",
                  "UUqUZQRmDdeZq",
                  "PSZmcvgbsODqImaNGN",
                ],
              },
              {
                displayNumber: 350722474890234,
                footnotes: [
                  "DGSEEZNwKulFWWrB",
                  "ZZHPLEcxJJtW",
                  "AJKHoiHFjKx",
                  "RiaOFKRPXBzuhDoVE",
                  "scbweFTTIkSUkMoP",
                  "bUGYySdrdYQSWeudklyn",
                  "ihYNYwoPqpm",
                  "nsJdkQhrSie",
                  "pDPhEAhGozexpQc",
                ],
              },
            ],
            targets: undefined,
            supportContacts: [
              {
                attribute: [
                  {
                    name: "QogwHtcFUt",
                    email: undefined,
                    phone: "vXCFlGDjdFNBlIew",
                  },
                  {
                    name: undefined,
                    email: "Vicente.Baumbach@hotmail.com",
                    phone: "RpeiggAmsZJXhtCdaIHv",
                  },
                  {
                    name: undefined,
                    email: "Ed87@hotmail.com",
                    phone: "vYjPrMvERPTdJh",
                  },
                  {
                    name: "uBZhJugiXTVZksIz",
                    email: "Carolyn.Marks74@hotmail.com",
                    phone: "DnKDPMFzgnvFAoazoM",
                  },
                  {
                    name: "WjyeGCvBUkbSEUFQ",
                    email: "Chester.Franecki@yahoo.com",
                    phone: "eeiAlouQaHIPWbhU",
                  },
                  {
                    name: "IJWZLoTcmUnlhSAJ",
                    email: undefined,
                    phone: undefined,
                  },
                  {
                    name: undefined,
                    email: "Tyrell_Kutch51@yahoo.com",
                    phone: undefined,
                  },
                  {
                    name: undefined,
                    email: undefined,
                    phone: undefined,
                  },
                  {
                    name: undefined,
                    email: "Norma43@hotmail.com",
                    phone: undefined,
                  },
                  {
                    name: undefined,
                    email: undefined,
                    phone: undefined,
                  },
                ],
                footnotes: [
                  "rfXdppqiOgHgdVj",
                  "CeXmSiSaAOWVQUkoptu",
                  "iJiqAPMHiCetvco",
                  "XscjuXhNfZtOrGjhWVUG",
                  "drqHshFQtgkmpHFKsQ",
                  "yPjfTrJbJqcF",
                  "uehpeVazgpWi",
                  "kMCTCBkiVrtNrXMFTcny",
                  "MVwrYxzsVDNQ",
                  "wSsPWGMPRucuJ",
                ],
                displayNumber: 6746060334258247,
              },
            ],
            generalDisclaimerContent: undefined,
            estimatedCloseDate: undefined,
            generalPartnerCommitmentPercentage: 0.6,
            generalPartnerCommitmentWithFootnotes: {
              attribute: undefined,
              footnotes: [
                "NEjIGFzBrBkPjewIwoDs",
                "VArMbyrVaCMzeYAFmzwd",
                "RmkANdDgbcR",
                "cwRnvcxEDrq",
                "tfNYYSFKoGx",
                "NoqWczVFCmrSDAf",
                "YtFeJWDgEN",
                "THUGgqkVNJpjNy",
              ],
              displayNumber: 5554037022187182,
            },
            strategy: undefined,
            fundingStatus: "OPEN",
            additionalFootnotes: undefined,
          },
          shareClasses: [
            {
              shareClassId: "d776fb1d-7186-4e3d-980f-847d4324c732",
              code: "rZzjUxKZcfLojcbOgyFw",
              name: "OaNUwByuUU",
              fundVehicleId: "59ef874f-2944-46f0-b912-784514ff59e0",
              attributes: {
                name: {
                  attribute: undefined,
                  footnotes: [
                    "ZFtOitswOzPDrQm",
                    "AnaHAxYDShDT",
                    "LtexuTmYXmsUYxqB",
                    "oMccusqzqjqYvxDZm",
                    "LFeJdEMkRbRxlgXdk",
                    "GCgpmlvKltuYX",
                    "mdqnAOSRsJqdKavrKN",
                  ],
                  displayNumber: 7310486239635341,
                },
                lockUp: {
                  attribute: {
                    durationYears: undefined,
                    lockUpType: undefined,
                  },
                  footnotes: [
                    "ViNDoyrEUDGAcmzq",
                    "AqnygWTKfOQ",
                    "fHREHxBbHewpCgJPif",
                    "TByfHTRGdfc",
                    "hnuXFRKfMoHr",
                    "noWbKLRYYdQHHgHZVwcs",
                    "KxcwyWHqBdYsysJILnq",
                  ],
                  displayNumber: 5904308929887594,
                },
                investorTypes: {
                  attribute: [
                    "KNOWLEDGEABLE_EMPLOYEE",
                    "EU_PROFESSIONAL_CLIENT",
                    "ACCREDITED_INVESTOR",
                    "NON_ACCREDITED_OR_RETAIL",
                    "RETIREMENT_PLAN",
                  ],
                  footnotes: undefined,
                  displayNumber: 1273469844170052,
                },
                nonQualifiedMinimumInvestment: undefined,
                nonQualifiedMinimumSubsequentInvestment: {
                  attribute: {
                    amount: 1,
                    currency: "EUR",
                  },
                  footnotes: [
                    "YZJmPfOVtGwwqNWWj",
                    "MndnVGLnLbtGhQmHvEf",
                    "VoQZknIYVA",
                    "hYYipfoQterZGviZQo",
                    "cgEWzRxKMj",
                    "HdsBZyQwPEUvF",
                    "vheaTmkMqAiXSSvN",
                  ],
                  displayNumber: 77633073721294,
                },
                fees: undefined,
                dividendTreatment: undefined,
                distributionSchedule: {
                  attribute: {
                    distributionSchedule: "WEEKLY",
                  },
                  footnotes: undefined,
                  displayNumber: 8518781326191482,
                },
                subscriptionSchedule: {
                  attribute: {
                    nextSubscriptionDates: undefined,
                    additionalInformation: undefined,
                  },
                  footnotes: [
                    "wjZDJqeYow",
                    "bQBodiUJmdJDvslIY",
                    "FwxnQzCpjeL",
                    "JuvytfqIIoxk",
                    "bUklogHdgHrK",
                    "nHgBwnFTZFvlnytV",
                  ],
                  displayNumber: 3363689843052221,
                },
                redemptionSchedule: {
                  attribute: {
                    nextRedemptionDates: undefined,
                    additionalInformation: undefined,
                  },
                  footnotes: undefined,
                  displayNumber: 3220193785369780,
                },
                inceptionDate: {
                  attribute: "2025-01-01T10:00:00Z",
                  footnotes: undefined,
                  displayNumber: 1481912811602524,
                },
                redemptionGates: undefined,
                investorTargetRegion: {
                  attribute: [
                    "vQlBPsHmfPfo",
                    "sYYncKxfKbThgjXKPur",
                    "yCGnXiYazrxD",
                    "vMJRmFEtzqhlfJ",
                    "XLcTSxEYBVejwEQZu",
                  ],
                  footnotes: undefined,
                  displayNumber: 2551708275851614,
                },
                valuationFrequency: undefined,
                customFields: {
                  loanProgramEligible: undefined,
                },
                globalFootnotes: undefined,
                redemptionScheduleFrequencyWithFootnotes: {
                  attribute: "ANNUALLY",
                  footnotes: [
                    "AMAdLPpIwURB",
                    "TzqNluTLulsojMnxu",
                    "ueeEFvwcAAhfgfFknjXS",
                  ],
                  displayNumber: 2950454878493642,
                },
                description: {
                  attribute: "bIBUiPPguinnCvX",
                  footnotes: [
                    "OrhSqIDyzMeI",
                    "dhLwuhAgyNnzZJRvNcg",
                    "uRsIKEsEreZg",
                    "TpHrunrvLA",
                    "cAEVcDSmTaMWIwcVybJz",
                    "ldDGAQSGaKv",
                    "HsVgIaWfertlExbq",
                    "JLKqfoRYzahqEdXsVO",
                    "FGHGCZMOTlezARxDBb",
                    "RiEEigYuliIFHeUu",
                  ],
                  displayNumber: 4164581683070803,
                },
                subscriptionScheduleFrequency: {
                  attribute: undefined,
                  footnotes: undefined,
                  displayNumber: 4368422144201585,
                },
              },
            },
            {
              shareClassId: "8691f65b-5d7b-41db-a325-f47069f8d805",
              code: "SllkVSOuAynAbgUNvAtM",
              name: "NLkryrNrhuYlFwdzKA",
              fundVehicleId: "d41e69c5-b242-4c3b-bf88-7579ffde7ae6",
              attributes: {
                name: {
                  attribute: "FKXmMBnOCIqzGv",
                  footnotes: undefined,
                  displayNumber: 1483792042084004,
                },
                lockUp: undefined,
                investorTypes: {
                  attribute: [
                    "NON_ACCREDITED_OR_RETAIL",
                    "INSTITUTIONAL_INVESTOR",
                    "QUALIFIED_CLIENT",
                  ],
                  footnotes: [
                    "dZNSHSfsTkeORiSJBR",
                    "koABPPEOjcTdmK",
                    "TpapEtBTVnyCXZ",
                    "LtaaxzbJpDpi",
                    "mBkAiINfydFnBA",
                    "CEuXOoRwRQjKpppLlaLi",
                    "mtycYLqqxGh",
                    "SntTIrJbMzQX",
                    "VAsyJTkVQYToffpFPUGa",
                  ],
                  displayNumber: 898253789026204,
                },
                nonQualifiedMinimumInvestment: undefined,
                nonQualifiedMinimumSubsequentInvestment: {
                  attribute: {
                    amount: 0.74,
                    currency: "RUB",
                  },
                  footnotes: undefined,
                  displayNumber: 5046206495061713,
                },
                fees: undefined,
                dividendTreatment: {
                  attribute: {
                    dividendTreatment: undefined,
                    dividendTreatmentAdditionalInformation:
                      "rXbtUoopFwLUJkWnheD",
                  },
                  footnotes: ["oFQNnmYaTkXrw", "EqCLcaxgIlwkCgbcX"],
                  displayNumber: 6381404793654302,
                },
                distributionSchedule: {
                  attribute: undefined,
                  footnotes: [
                    "XOFxsXFEmcXqxfRbRhUL",
                    "DqjSuuitTsX",
                    "hjSuaoFPgfVNENwNtmLv",
                    "sVWmPwVxMylkwNFJozcQ",
                    "vaiHFOnNJqChxTvREjEA",
                  ],
                  displayNumber: 1077535205653486,
                },
                subscriptionSchedule: {
                  attribute: {
                    nextSubscriptionDates: ["2025-01-01T10:00:00Z"],
                    additionalInformation: "pWtNBKnWBRsfJa",
                  },
                  footnotes: undefined,
                  displayNumber: 7500823257866388,
                },
                redemptionSchedule: {
                  attribute: {
                    nextRedemptionDates: [
                      "2025-01-01T10:00:00Z",
                      "2025-01-01T10:00:00Z",
                      "2025-01-01T10:00:00Z",
                      "2025-01-01T10:00:00Z",
                      "2025-01-01T10:00:00Z",
                      "2025-01-01T10:00:00Z",
                      "2025-01-01T10:00:00Z",
                      "2025-01-01T10:00:00Z",
                      "2025-01-01T10:00:00Z",
                    ],
                    additionalInformation: undefined,
                  },
                  footnotes: [
                    "wQnazfNoxeoOhHVJQfn",
                    "LHIvcOJyUrpTPAglIuR",
                    "PtPsibuUmkYbOqbVhCod",
                  ],
                  displayNumber: 1040842211639000,
                },
                inceptionDate: undefined,
                redemptionGates: {
                  attribute: [
                    {
                      gatePercentage: 0.91,
                      gateFrequency: "KfDmwGncabafmlZ",
                      gateType: "FUND_LEVEL",
                      additionalInformation: "CSJpDLLITTE",
                    },
                    {
                      gatePercentage: 0.64,
                      gateFrequency: "aZjyTlygujstZZfLcbf",
                      gateType: "INVESTOR_LEVEL",
                      additionalInformation: undefined,
                    },
                    {
                      gatePercentage: 0.92,
                      gateFrequency: "fEOeiaEUIZdUQqY",
                      gateType: "FUND_LEVEL",
                      additionalInformation: "TNDgBsPNVaQWPgebGGZ",
                    },
                    {
                      gatePercentage: 0.33,
                      gateFrequency: "QWPwHSzliaLfmpDu",
                      gateType: "INVESTOR_LEVEL",
                      additionalInformation: undefined,
                    },
                    {
                      gatePercentage: 0.42,
                      gateFrequency: "NOywaWFkVVZTZmRQm",
                      gateType: "FUND_LEVEL",
                      additionalInformation: undefined,
                    },
                    {
                      gatePercentage: 0.83,
                      gateFrequency: "oCLZgcKRSJXAV",
                      gateType: "INVESTOR_LEVEL",
                      additionalInformation: "qkCxTfnNequGiSxVyoh",
                    },
                    {
                      gatePercentage: 0.53,
                      gateFrequency: "uEojOXfiXbY",
                      gateType: "FUND_LEVEL",
                      additionalInformation: "pWqIemOBWwTxYXrUSkG",
                    },
                    {
                      gatePercentage: 0.84,
                      gateFrequency: "duDSYwdMDxq",
                      gateType: "CLASS_LEVEL",
                      additionalInformation: "NCTCmSCkGsRxL",
                    },
                    {
                      gatePercentage: 0.39,
                      gateFrequency: "QiorHNMAQwgDXPEHWwrY",
                      gateType: "INVESTOR_LEVEL",
                      additionalInformation: "yvhXvTjCbNEGc",
                    },
                  ],
                  footnotes: undefined,
                  displayNumber: 3664706086208840,
                },
                investorTargetRegion: undefined,
                valuationFrequency: undefined,
                customFields: {
                  loanProgramEligible: undefined,
                },
                globalFootnotes: [
                  {
                    displayNumber: 7041128211621190,
                    footnotes: ["phlywpiNZOpmlhCFKJ"],
                  },
                  {
                    displayNumber: 2633104383527649,
                    footnotes: [
                      "sltoeRSldMkudlPPk",
                      "gdZICNRPajItZ",
                      "XkSqZiAPwyZwFcRHv",
                      "EaaGjjHcqh",
                    ],
                  },
                  {
                    displayNumber: 5225764165649674,
                    footnotes: [
                      "neewXlnfFJHSzgpIF",
                      "JHTEOmJUuOLdEgY",
                      "fgErbCufPVNQlnkNXL",
                      "HuwdbKwCCoyyuQxFUTU",
                      "bnoVHehiGMSW",
                      "qmsVDMzbdBLl",
                      "QvMvJNZrvikKVujox",
                    ],
                  },
                  {
                    displayNumber: 2617945430049970,
                    footnotes: [
                      "aCPnFIIxsRNqfdeEcr",
                      "pNMmLMukBVHiJwEMAQ",
                      "FhRWhznNLhTjPxrii",
                    ],
                  },
                  {
                    displayNumber: 5961780111022051,
                    footnotes: [
                      "fdMLdDeUVKW",
                      "RDplrGinymEWMIEzjU",
                      "eNjtbhjcIRtT",
                      "qhGvFNCGWpsL",
                      "jtyvjWNzJUhnCPbZ",
                      "spjPXvXQzJwDdKc",
                    ],
                  },
                  {
                    displayNumber: 7359646924954750,
                    footnotes: [
                      "qzFoEpcafPXw",
                      "hChFWkNbtfsjtvp",
                      "VukoSDxhxoXTeAlvT",
                      "rkPGylrXBuBOrjE",
                      "LTtdXwGICkNPCzfer",
                      "XOIAiYtfzTUaU",
                      "cSSFDQOUCYZg",
                      "zuFcATlwWwswBGPxQBr",
                      "LDciooJaNnqBlTexS",
                    ],
                  },
                  {
                    displayNumber: 5547028666867745,
                    footnotes: [
                      "KYUrZabQkdmwLG",
                      "AWQqZKdbiLjA",
                      "VrVXaybVAdf",
                    ],
                  },
                  {
                    displayNumber: 3454342199597444,
                    footnotes: [
                      "TtcYaXtaJYYijDHMj",
                      "HSCvYETXJCackjnpsvfc",
                      "BxGRwHXRwHjDZAWvZ",
                      "cEobQoPokYsFFDVJ",
                      "SjCXGQHRXoizKl",
                      "rYKuksifVZ",
                      "crykpkOLHuV",
                      "jlBewEBrCXkIcdCfbiDK",
                      "IjFvHZWaUdXo",
                      "efLXFLNncasmdj",
                    ],
                  },
                  {
                    displayNumber: 1121386383695134,
                    footnotes: [
                      "BECfqcujDKB",
                      "uRlMNvpyecfjAS",
                      "WXXRsdDDSZAr",
                      "aACQAVGRhSJi",
                      "WbyqIRswZOUw",
                      "vLfocwRbJWmK",
                      "YmfhKLJriEzLwrpknesb",
                      "MqILEXbMXSiq",
                      "FLqCJvSOdGm",
                      "XTvpmBfCaqlYLseA",
                    ],
                  },
                ],
                redemptionScheduleFrequencyWithFootnotes: {
                  attribute: undefined,
                  footnotes: [
                    "CWWApxjHAfkyUDJr",
                    "xIczpqXjqASvMSqu",
                    "RcqJDwCkwAUnT",
                    "bLbZTpntstqGiRQyS",
                    "aGxDUYGNeiMw",
                    "qFjGjdrmUcjCzc",
                    "ZItynrHTjR",
                  ],
                  displayNumber: 1936477796080466,
                },
                description: {
                  attribute: undefined,
                  footnotes: undefined,
                  displayNumber: 1508011850166574,
                },
                subscriptionScheduleFrequency: {
                  attribute: undefined,
                  footnotes: undefined,
                  displayNumber: 1308141390108340,
                },
              },
            },
            {
              shareClassId: "e88c57fa-223c-440f-9203-36ee76830f23",
              code: "ahtJlvCUqgzMfwa",
              name: "zpRFxvzcUZ",
              fundVehicleId: "212aadc7-9b87-4a8a-b9ba-8a73089f5631",
              attributes: {
                name: undefined,
                lockUp: {
                  attribute: undefined,
                  footnotes: [
                    "vDPKZasonlKeMKnnGNTS",
                    "EVQUaYyPguopgPaqjEnn",
                    "HgjmYuFmzdbyuhJ",
                    "uGYRyMgAoiwgKxBhhEZf",
                    "TdTBvqppULIPn",
                    "xOqHTudArIXzyIfn",
                    "IakJNRpWCKFgYgnQGRAt",
                    "bSmShEUyMPMWxjcmhDjc",
                    "REsUdYGjJN",
                  ],
                  displayNumber: 7760896568835433,
                },
                investorTypes: {
                  attribute: [
                    "RETIREMENT_PLAN",
                    "QUALIFIED_PURCHASER",
                    "KNOWLEDGEABLE_EMPLOYEE",
                  ],
                  footnotes: undefined,
                  displayNumber: 2615789041488287,
                },
                nonQualifiedMinimumInvestment: undefined,
                nonQualifiedMinimumSubsequentInvestment: undefined,
                fees: {
                  managementFees: undefined,
                  incentiveFees: {
                    attribute: [
                      {
                        type: undefined,
                        name: "yncvcCpBgWUjrFe",
                        structure: undefined,
                        paymentFrequency: undefined,
                        rate: undefined,
                        feeBasis: undefined,
                        applicablePeriod: "INVESTMENT_PERIOD",
                        additionalInformation: "CadUTsUEPwfwxCfZm",
                      },
                      {
                        type: undefined,
                        name: "OAFLbDTavWsxZk",
                        structure: undefined,
                        paymentFrequency: undefined,
                        rate: undefined,
                        feeBasis: "NET",
                        applicablePeriod: undefined,
                        additionalInformation: undefined,
                      },
                      {
                        type: undefined,
                        name: "dDpRIYnzAmE",
                        structure: "SINGLE_RATE",
                        paymentFrequency: undefined,
                        rate: 0.33,
                        feeBasis: "NET",
                        applicablePeriod: "INVESTMENT_PERIOD",
                        additionalInformation: "KGPxAQwKwvNjrls",
                      },
                      {
                        type: undefined,
                        name: undefined,
                        structure: undefined,
                        paymentFrequency: "SEMI_ANNUALLY_IN_ARREARS",
                        rate: 0.42,
                        feeBasis: "GROSS",
                        applicablePeriod: undefined,
                        additionalInformation: "bWJbQkEyvUwdXVJy",
                      },
                      {
                        type: "PASS_THROUGH",
                        name: "BiawhidkLQ",
                        structure: "TIERED_RATE",
                        paymentFrequency: "MONTHLY_IN_ADVANCE",
                        rate: undefined,
                        feeBasis: "GROSS",
                        applicablePeriod: undefined,
                        additionalInformation: undefined,
                      },
                      {
                        type: "ADMINISTRATION",
                        name: undefined,
                        structure: undefined,
                        paymentFrequency: undefined,
                        rate: undefined,
                        feeBasis: "NET",
                        applicablePeriod: "POST_INVESTMENT_PERIOD",
                        additionalInformation: "vFZzkicDCkKMn",
                      },
                    ],
                    footnotes: [
                      "NxPNISWEmuNHjc",
                      "nzMDejlnDAkdiZyTS",
                      "KkJoReOfTpIztHX",
                      "VFPtyTvBbi",
                      "LEhxszTOeUyMhImwa",
                      "emfJbGhXWlF",
                      "WBcrduIytg",
                      "fPhErlHxuEzp",
                      "IbycjDTTdvEhNMUa",
                      "RIUcFDbAFjoH",
                    ],
                    displayNumber: 7728299977007026,
                  },
                  additionalFees: undefined,
                  generalPartnerCommitment: {
                    attribute: {
                      value: undefined,
                    },
                    footnotes: [
                      "CHiYzcWEKBRb",
                      "ydKuoaLRuDlG",
                      "zHVtNFWuqU",
                      "heRaSxaujG",
                      "zcIRLRkUqaRWImnyU",
                      "QpQVwsPBJGh",
                      "kWnMoqqMCTpJNhuzsqJ",
                      "KWDFdSoFYELx",
                      "PbKbSiAFxr",
                    ],
                    displayNumber: 2804983746272977,
                  },
                  catchUp: undefined,
                  carriedInterestRate: undefined,
                  hurdleRate: {
                    attribute: {
                      value: 0.31,
                    },
                    footnotes: [
                      "IngafpCdhjGGCntflUY",
                      "VHbZfJnuHwnrrXPxk",
                      "iktTggzoDxwfhQUmfc",
                      "LtJLWdjdTPDeopDn",
                      "LpxgPDUzWU",
                      "WqtcELOhxjIiVlpS",
                      "bzeZEnDdPWTrqbH",
                      "xViadlbAqjNkJsA",
                      "bASEouJUcdqmnlkgWhkm",
                      "NPfRvnDQOUWmwaTiSrtc",
                    ],
                    displayNumber: 8001668701666509,
                  },
                },
                dividendTreatment: undefined,
                distributionSchedule: undefined,
                subscriptionSchedule: undefined,
                redemptionSchedule: {
                  attribute: {
                    nextRedemptionDates: [
                      "2025-01-01T10:00:00Z",
                      "2025-01-01T10:00:00Z",
                      "2025-01-01T10:00:00Z",
                      "2025-01-01T10:00:00Z",
                    ],
                    additionalInformation: "NMrBsaDgeNaXAZdEsR",
                  },
                  footnotes: [
                    "auInwcENvvekiz",
                    "XdFBATkcIranqGi",
                    "zxYcXEPwxTUmkz",
                    "qHKODuYFLrInmLBJoFx",
                    "pLPnpIKKJuuniKeW",
                    "SVvSibOdZJNmJcRiKld",
                    "iLmrDotQjerwCtP",
                    "wtHYAZpbiu",
                    "fwrgpUpLFwmtE",
                  ],
                  displayNumber: 1935614996336318,
                },
                inceptionDate: {
                  attribute: "2025-01-01T10:00:00Z",
                  footnotes: undefined,
                  displayNumber: 4443193571212798,
                },
                redemptionGates: undefined,
                investorTargetRegion: undefined,
                valuationFrequency: {
                  attribute: {
                    valuationFrequency: "DAILY",
                  },
                  footnotes: ["MKPnxIwKGf", "LIinuolPHDlVjPYLZH"],
                  displayNumber: 1835842791905047,
                },
                customFields: {
                  loanProgramEligible: undefined,
                },
                globalFootnotes: undefined,
                redemptionScheduleFrequencyWithFootnotes: {
                  attribute: "QUARTERLY",
                  footnotes: ["ZyLzwvAtMTTlUrqLp", "tLrGIMUwiq"],
                  displayNumber: 6430162710498132,
                },
                description: undefined,
                subscriptionScheduleFrequency: {
                  attribute: undefined,
                  footnotes: undefined,
                  displayNumber: 7463814851456327,
                },
              },
            },
            {
              shareClassId: "e757da0f-2ba3-42d6-8a8b-745d73ec0fb2",
              code: "OmnpFifJOAswuXNkt",
              name: "FyQNASNOXnnUOWd",
              fundVehicleId: "a28220a5-152f-455d-baba-f3fd9aa03f86",
              attributes: {
                name: undefined,
                lockUp: undefined,
                investorTypes: undefined,
                nonQualifiedMinimumInvestment: undefined,
                nonQualifiedMinimumSubsequentInvestment: undefined,
                fees: undefined,
                dividendTreatment: undefined,
                distributionSchedule: undefined,
                subscriptionSchedule: undefined,
                redemptionSchedule: undefined,
                inceptionDate: undefined,
                redemptionGates: {
                  attribute: [
                    {
                      gatePercentage: 0.9,
                      gateFrequency: "MMasbZgCPkzFi",
                      gateType: "INVESTOR_LEVEL",
                      additionalInformation: "kDvVTzsqnCPqj",
                    },
                    {
                      gatePercentage: 0.06,
                      gateFrequency: "AzpVeTtTLfRJbgHIM",
                      gateType: "INVESTOR_LEVEL",
                      additionalInformation: "NDnVatLwbdHYCAqnb",
                    },
                    {
                      gatePercentage: 0.45,
                      gateFrequency: "eLUWGcMfIOLX",
                      gateType: "INVESTOR_LEVEL",
                      additionalInformation: "nWjVqgQaRnUJIsdRi",
                    },
                    {
                      gatePercentage: 0.6,
                      gateFrequency: "khgSbYkfEeFScPu",
                      gateType: "FUND_LEVEL",
                      additionalInformation: undefined,
                    },
                  ],
                  footnotes: undefined,
                  displayNumber: 6670679521587412,
                },
                investorTargetRegion: undefined,
                valuationFrequency: {
                  attribute: {
                    valuationFrequency: undefined,
                  },
                  footnotes: [
                    "HFAWBZAgyjF",
                    "yfyeJPYhBDVGhwIKS",
                    "XdZSIMdcfeC",
                    "SxKHqmrPEnQc",
                    "wMWNwhPxdLpcUzoLU",
                    "JNkzeMSfQO",
                  ],
                  displayNumber: 6217575339573281,
                },
                customFields: undefined,
                globalFootnotes: undefined,
                redemptionScheduleFrequencyWithFootnotes: undefined,
                description: {
                  attribute: "jIfYTGQUnS",
                  footnotes: [
                    "LbpFsOHmhGxiqpfC",
                    "DQgwFJKLHeKLZKJATZ",
                    "FeLKOgHpNmJpaGfIWY",
                    "QsUOdvrOvJFY",
                    "wLRUdpqwizIzIdTWGTgP",
                  ],
                  displayNumber: 3675029453071312,
                },
                subscriptionScheduleFrequency: undefined,
              },
            },
            {
              shareClassId: "931885a1-280e-42a6-96c7-b89c99cf6915",
              code: "AMayUlbwKxxInNhuIRP",
              name: "sglSSXdBHKHOsjkas",
              fundVehicleId: "15aed423-f82d-46e4-a68e-d936f9c786bd",
              attributes: {
                name: {
                  attribute: undefined,
                  footnotes: undefined,
                  displayNumber: 899525146811903,
                },
                lockUp: {
                  attribute: undefined,
                  footnotes: [
                    "vhJgjQIGvuJMAYXv",
                    "CAcDUOOismqEsDwoeUa",
                    "QZLalYQDma",
                  ],
                  displayNumber: 5512233577905206,
                },
                investorTypes: undefined,
                nonQualifiedMinimumInvestment: {
                  attribute: {
                    amount: 0.82,
                    currency: "NOK",
                  },
                  footnotes: [
                    "PqHhrVVDKSXzDvdvP",
                    "UcBfkUzNdvJgqdHYRY",
                    "SEAvQjcXaYLrKQmOPmc",
                  ],
                  displayNumber: 1807262184615010,
                },
                nonQualifiedMinimumSubsequentInvestment: {
                  attribute: {
                    amount: 0.73,
                    currency: "NZD",
                  },
                  footnotes: undefined,
                  displayNumber: 1847239945696656,
                },
                fees: undefined,
                dividendTreatment: undefined,
                distributionSchedule: undefined,
                subscriptionSchedule: undefined,
                redemptionSchedule: undefined,
                inceptionDate: undefined,
                redemptionGates: undefined,
                investorTargetRegion: {
                  attribute: [
                    "MaUuTchqrSaHgQO",
                    "lGijGZUECZCvVmf",
                    "etwCZltgFLzmGCiv",
                  ],
                  footnotes: [
                    "SMUMUcxMEjrqnrASMRTv",
                    "cWdMtXvQopEZA",
                    "OPwujYXMpmZdRsvResXK",
                    "NdkztvOaIadvRhCJlA",
                    "AiGEbeihnxtUFTBeyQke",
                  ],
                  displayNumber: 3502880250312254,
                },
                valuationFrequency: {
                  attribute: {
                    valuationFrequency: "WEEKLY",
                  },
                  footnotes: [
                    "GBCmBbwDjnldsY",
                    "xHHXSPXlGUGYf",
                    "YtMbKWtbbULfcP",
                    "gpOBXzJAXulqSzsCga",
                    "FLQWvMdcgxkoH",
                    "CvidmdGPruQlg",
                    "HFLcwmNToenfqBY",
                  ],
                  displayNumber: 1981943438156608,
                },
                customFields: undefined,
                globalFootnotes: undefined,
                redemptionScheduleFrequencyWithFootnotes: {
                  attribute: undefined,
                  footnotes: [
                    "ICooCiQdergyu",
                    "XNjWuyvoUrEmPOpJK",
                    "FDeIywSbngboZoIg",
                    "ZpSZEqJRixqoSvrF",
                    "lBvpcBQSmFSv",
                    "UknjkVWcEDuGXigbsrwA",
                    "urQSmqQeqxjjwNRYdl",
                    "CrkowjYfZRwMIlrAHC",
                    "xzwCUGLFHEbZbuf",
                  ],
                  displayNumber: 7147455367739300,
                },
                description: undefined,
                subscriptionScheduleFrequency: undefined,
              },
            },
            {
              shareClassId: "78c9af96-ba07-4b7c-97f4-16853a6acc69",
              code: "TreitDIrIWHiECTsvFB",
              name: "cDgqIiqKHeEhnxfZi",
              fundVehicleId: "cdf6df27-0993-4c0c-b0a1-4b48e0c121f2",
              attributes: {
                name: undefined,
                lockUp: {
                  attribute: undefined,
                  footnotes: undefined,
                  displayNumber: 7237951902998794,
                },
                investorTypes: undefined,
                nonQualifiedMinimumInvestment: undefined,
                nonQualifiedMinimumSubsequentInvestment: {
                  attribute: {
                    amount: 0.03,
                    currency: "ZAR",
                  },
                  footnotes: undefined,
                  displayNumber: 7012980835722213,
                },
                fees: {
                  managementFees: undefined,
                  incentiveFees: {
                    attribute: [
                      {
                        type: "OTHER",
                        name: undefined,
                        structure: undefined,
                        paymentFrequency: undefined,
                        rate: undefined,
                        feeBasis: "GROSS",
                        applicablePeriod: "POST_INVESTMENT_PERIOD",
                        additionalInformation: undefined,
                      },
                      {
                        type: "ADMINISTRATION",
                        name: "LIjfIJtRYkEaL",
                        structure: undefined,
                        paymentFrequency: "ONCE_OFF",
                        rate: 0.04,
                        feeBasis: undefined,
                        applicablePeriod: undefined,
                        additionalInformation: undefined,
                      },
                      {
                        type: undefined,
                        name: "tsrWcxnUevvUlHgXEGw",
                        structure: undefined,
                        paymentFrequency: "ONCE_ON_REDEMPTION",
                        rate: 0.89,
                        feeBasis: "NOT_APPLICABLE",
                        applicablePeriod: "INVESTMENT_PERIOD",
                        additionalInformation: "LyBbprDDKLmObLfLB",
                      },
                      {
                        type: "EXIT",
                        name: undefined,
                        structure: undefined,
                        paymentFrequency: undefined,
                        rate: undefined,
                        feeBasis: "NOT_APPLICABLE",
                        applicablePeriod: "POST_INVESTMENT_PERIOD",
                        additionalInformation: undefined,
                      },
                    ],
                    footnotes: [
                      "CKoDLRxMplj",
                      "boHHdoDqvLaoh",
                      "XtBMcmRSttN",
                      "gnucyMAdwKddt",
                      "WEoKtgmHcokk",
                      "QLHVdivtvkhAWucKp",
                      "qLQEqqgWHbIx",
                      "QiLzjKCbHHhsEhSbfgBG",
                      "pQdocasknQiOJq",
                      "xgVDTQekhRSBfhQW",
                    ],
                    displayNumber: 100318370499778,
                  },
                  additionalFees: undefined,
                  generalPartnerCommitment: undefined,
                  catchUp: undefined,
                  carriedInterestRate: {
                    attribute: {
                      value: undefined,
                      additionalInformation: "fBELnRXzNB",
                    },
                    footnotes: [
                      "ZlHoHkOfUR",
                      "dkSgiColDthBuMfGw",
                      "mbSqJXDunWJIwR",
                      "oFwaPgArryZvjFmfc",
                    ],
                    displayNumber: 3883585898938075,
                  },
                  hurdleRate: {
                    attribute: {
                      value: undefined,
                    },
                    footnotes: undefined,
                    displayNumber: 5331648426427262,
                  },
                },
                dividendTreatment: {
                  attribute: {
                    dividendTreatment: "ACCUMULATION",
                    dividendTreatmentAdditionalInformation: "pCDESuAaPnQnaiZ",
                  },
                  footnotes: ["qbAlBhwFdup", "FEGiokCxrOeY"],
                  displayNumber: 6963202846827830,
                },
                distributionSchedule: {
                  attribute: {
                    distributionSchedule: "ANNUALLY",
                  },
                  footnotes: [
                    "ZZjGBiiZxglnA",
                    "xiqdUkNsypKRo",
                    "JkHeGAfHxlsz",
                    "XIfQqFoMLCm",
                  ],
                  displayNumber: 3448521497058742,
                },
                subscriptionSchedule: undefined,
                redemptionSchedule: {
                  attribute: {
                    nextRedemptionDates: ["2025-01-01T10:00:00Z"],
                    additionalInformation: "IBkRkmjiXFHXlaFAydxo",
                  },
                  footnotes: [
                    "qYWDZZsxXFlJk",
                    "lmaTpeeCZhfwD",
                    "pwqVcmQRfYKox",
                    "hpEQssyHNqEuL",
                  ],
                  displayNumber: 2314173453014464,
                },
                inceptionDate: undefined,
                redemptionGates: undefined,
                investorTargetRegion: {
                  attribute: [
                    "tlCUEVsKHIHlhYc",
                    "wsOMVuDUZYLhbQR",
                    "oHqxtVmEsIDWflNtiA",
                    "cpQBboHkRJyVumIDr",
                    "upKHwusoenqCO",
                    "XRZTGFgLFAKxBu",
                    "TROaVoUkwMHvJCoHk",
                  ],
                  footnotes: undefined,
                  displayNumber: 3286911785343239,
                },
                valuationFrequency: undefined,
                customFields: undefined,
                globalFootnotes: [
                  {
                    displayNumber: 5479334623868772,
                    footnotes: [
                      "vBOIwYfkrlGc",
                      "pJTPjDbqPxh",
                      "kuzsWDRNIzaFsg",
                      "MYtCSrhoUirySW",
                      "WiiXAjzOQSDTAF",
                      "wdsGkhpbMngKRbmXuW",
                    ],
                  },
                  {
                    displayNumber: 2469886971253001,
                    footnotes: [
                      "eUYXSSIQkuHT",
                      "RyLYhWBHTvvBazpWe",
                      "XUKEoteOqIsyCPk",
                    ],
                  },
                  {
                    displayNumber: 3591759295070386,
                    footnotes: ["FjdUBhcgyI", "hGvyPrhTlpKJPjsgC"],
                  },
                  {
                    displayNumber: 2635241623073720,
                    footnotes: [
                      "dwXUZvcpJh",
                      "cykevsBMfPbxE",
                      "DiAuykAhMEeUGqcGtVbc",
                      "YbLlKTfmbcbPpzOzwaDg",
                      "nJHGnnSajFQsHCdGQZ",
                      "IvaFgtnszs",
                      "mHSlAHDtHbtBbAIN",
                    ],
                  },
                  {
                    displayNumber: 1021182941577966,
                    footnotes: [
                      "smDTBIsuoKsjtSMr",
                      "dcggeIFHJNkGEXmdHMo",
                      "dXfdcwfMUnGcuplH",
                      "SIKWXCzrLBW",
                      "qqPfxwdvAdAX",
                      "BAoZoxasdMDDoQarIVmC",
                      "TcwjbhYlWkWIfEq",
                      "wvINrWWcawEonJ",
                      "iTJsJfyicrhGJhbP",
                      "rzQRLmLmlC",
                    ],
                  },
                  {
                    displayNumber: 6114577240579779,
                    footnotes: ["OSFwRLEqkv"],
                  },
                ],
                redemptionScheduleFrequencyWithFootnotes: undefined,
                description: {
                  attribute: undefined,
                  footnotes: undefined,
                  displayNumber: 8986882805314887,
                },
                subscriptionScheduleFrequency: {
                  attribute: "SEMI_ANNUALLY",
                  footnotes: undefined,
                  displayNumber: 3477209155229431,
                },
              },
            },
            {
              shareClassId: "233fd094-1b27-4a8f-acc5-0bf6f2427c5e",
              code: "OfOmoFUEHOnRvjs",
              name: "lojIEHrOgDoB",
              fundVehicleId: "5ceb24e6-f6fe-4a06-9ee2-6d9dde121e71",
              attributes: {
                name: {
                  attribute: "QMJbVlGdeaDGc",
                  footnotes: [
                    "lwRnZsugJmG",
                    "uSMiFGeynyOi",
                    "oXMbunHxYlE",
                    "QvJpwUXLtQbfIpXww",
                    "NylOqjGeYGZrYhcby",
                    "ArrHiNEVsZ",
                    "YbLQcEPDdKdQchoG",
                    "ghtRyqDnurPWNwAgMFUk",
                    "JnIWVLcTIqjgcNmbuz",
                  ],
                  displayNumber: 396752140655899,
                },
                lockUp: {
                  attribute: {
                    durationYears: 0.68,
                    lockUpType: "HARD_LOCK",
                  },
                  footnotes: [
                    "jsrMdSQNqQj",
                    "cWqVoVVWzTX",
                    "vLpNdBgpnRkQP",
                    "mlyaBXiDYSSQqUW",
                  ],
                  displayNumber: 3193692072628130,
                },
                investorTypes: {
                  attribute: [
                    "QUALIFIED_CLIENT",
                    "INSTITUTIONAL_INVESTOR",
                    "QUALIFIED_PURCHASER",
                  ],
                  footnotes: [
                    "PjfGudsOFsj",
                    "UHQBLUOVwVGTcISj",
                    "QovDAcffnmMDNdzqS",
                    "TcLCQACcIobdXrTXX",
                    "UphHzfJDSFDwyXhxIwo",
                  ],
                  displayNumber: 2104586565718224,
                },
                nonQualifiedMinimumInvestment: undefined,
                nonQualifiedMinimumSubsequentInvestment: undefined,
                fees: {
                  managementFees: undefined,
                  incentiveFees: {
                    attribute: [
                      {
                        type: undefined,
                        name: "jnmqDbtmFZA",
                        structure: undefined,
                        paymentFrequency: undefined,
                        rate: 0.42,
                        feeBasis: undefined,
                        applicablePeriod: "POST_INVESTMENT_PERIOD",
                        additionalInformation: undefined,
                      },
                      {
                        type: undefined,
                        name: "GkBOmuXNDl",
                        structure: undefined,
                        paymentFrequency: undefined,
                        rate: 0.09,
                        feeBasis: "GROSS",
                        applicablePeriod: undefined,
                        additionalInformation: "PILpnFkQBlGXefR",
                      },
                      {
                        type: "TRAIL",
                        name: "DAVNZyeXaObNWum",
                        structure: "SINGLE_RATE",
                        paymentFrequency: "ONCE_ON_SUBSCRIPTION",
                        rate: 0.32,
                        feeBasis: "GROSS",
                        applicablePeriod: undefined,
                        additionalInformation: "jNjcGmiZpUjQA",
                      },
                      {
                        type: undefined,
                        name: undefined,
                        structure: undefined,
                        paymentFrequency: "ONCE_ON_TRANSFER",
                        rate: undefined,
                        feeBasis: undefined,
                        applicablePeriod: undefined,
                        additionalInformation: undefined,
                      },
                      {
                        type: undefined,
                        name: "QSovLfNfVoDgo",
                        structure: "SINGLE_RATE",
                        paymentFrequency: "ONCE_ON_TRANSFER",
                        rate: 0.78,
                        feeBasis: "GROSS",
                        applicablePeriod: undefined,
                        additionalInformation: undefined,
                      },
                      {
                        type: undefined,
                        name: "AnUNzYCreCSTF",
                        structure: undefined,
                        paymentFrequency: "SEMI_ANNUALLY_IN_ARREARS",
                        rate: undefined,
                        feeBasis: "NOT_APPLICABLE",
                        applicablePeriod: undefined,
                        additionalInformation: undefined,
                      },
                      {
                        type: undefined,
                        name: undefined,
                        structure: undefined,
                        paymentFrequency: "ONCE_OFF",
                        rate: 0.08,
                        feeBasis: undefined,
                        applicablePeriod: undefined,
                        additionalInformation: "zrkHJRTKJcfQm",
                      },
                      {
                        type: "BROKERAGE",
                        name: undefined,
                        structure: undefined,
                        paymentFrequency: undefined,
                        rate: undefined,
                        feeBasis: "NOT_APPLICABLE",
                        applicablePeriod: undefined,
                        additionalInformation: undefined,
                      },
                      {
                        type: "BROKERAGE",
                        name: undefined,
                        structure: undefined,
                        paymentFrequency: "SEMI_ANNUALLY_IN_ARREARS",
                        rate: 0.55,
                        feeBasis: undefined,
                        applicablePeriod: "POST_INVESTMENT_PERIOD",
                        additionalInformation: undefined,
                      },
                    ],
                    footnotes: [
                      "fRtEtuiDCjCYLzVDhCjN",
                      "swvoPGdRjYtGerPyVDWZ",
                      "DRlSELeNqPAoXN",
                      "sHFJbpVwXlZKOuVCJeGT",
                      "MbWZsfIbzoy",
                      "caGDmHToRI",
                      "tAMoZJtfjz",
                      "NLkEbuNuRYFhtaF",
                      "GOPSnTIpZXDRnvjBzlI",
                      "duvqnriuVlJ",
                    ],
                    displayNumber: 3187707480032851,
                  },
                  additionalFees: undefined,
                  generalPartnerCommitment: {
                    attribute: undefined,
                    footnotes: undefined,
                    displayNumber: 7862496947026873,
                  },
                  catchUp: undefined,
                  carriedInterestRate: {
                    attribute: {
                      value: undefined,
                      additionalInformation: undefined,
                    },
                    footnotes: undefined,
                    displayNumber: 6293559780546952,
                  },
                  hurdleRate: {
                    attribute: {
                      value: 0.41,
                    },
                    footnotes: [
                      "QvLVVKHBjgziEHBbdf",
                      "ZrpcHHjVPlz",
                      "sQfvwySlfGjdwls",
                      "eDbYrKQoMRmZ",
                      "lOkKSXyYvl",
                      "HxDvBXznNrQcree",
                      "uTApLGPHiIuyVsFse",
                    ],
                    displayNumber: 5377851938003512,
                  },
                },
                dividendTreatment: {
                  attribute: {
                    dividendTreatment: "ACCUMULATION",
                    dividendTreatmentAdditionalInformation: undefined,
                  },
                  footnotes: undefined,
                  displayNumber: 5007991299962385,
                },
                distributionSchedule: undefined,
                subscriptionSchedule: {
                  attribute: undefined,
                  footnotes: ["GFZGWomAAlKbJxJyYrZ", "JxQPPeQlbl"],
                  displayNumber: 6684344887929075,
                },
                redemptionSchedule: undefined,
                inceptionDate: undefined,
                redemptionGates: {
                  attribute: [
                    {
                      gatePercentage: 0.9,
                      gateFrequency: "aGJBJqhImxzyFbZ",
                      gateType: "INVESTOR_LEVEL",
                      additionalInformation: undefined,
                    },
                    {
                      gatePercentage: 0.21,
                      gateFrequency: "RhwWALQklNNdqu",
                      gateType: "INVESTOR_LEVEL",
                      additionalInformation: "WZOIudDssJyNuh",
                    },
                    {
                      gatePercentage: 0.96,
                      gateFrequency: "kuWgnnDveGfFAzdHwv",
                      gateType: "CLASS_LEVEL",
                      additionalInformation: "agmJDNMStrRmxkVv",
                    },
                    {
                      gatePercentage: 0.69,
                      gateFrequency: "XtIrPUOSfWGT",
                      gateType: "INVESTOR_LEVEL",
                      additionalInformation: undefined,
                    },
                    {
                      gatePercentage: 0.88,
                      gateFrequency: "WCxYyHtHLGApHVaggW",
                      gateType: "CLASS_LEVEL",
                      additionalInformation: "EyPityptekrPjsdCFTQo",
                    },
                    {
                      gatePercentage: 0.15,
                      gateFrequency: "JchzkPDFynELtARhCsKa",
                      gateType: "INVESTOR_LEVEL",
                      additionalInformation: "dLHUBBKqblm",
                    },
                    {
                      gatePercentage: 0.95,
                      gateFrequency: "WZwlDTyAgvusUdYaXC",
                      gateType: "INVESTOR_LEVEL",
                      additionalInformation: "IThgpifJlISH",
                    },
                  ],
                  footnotes: undefined,
                  displayNumber: 7109764741759259,
                },
                investorTargetRegion: {
                  attribute: [
                    "IwgJkApWlv",
                    "qHqfGVxGFvFntxSsHlnH",
                    "yrVhLJJWLpsubVdKLR",
                  ],
                  footnotes: [
                    "pMrUiqzOMkhpzCwIw",
                    "nGFovtiyujxvggHKWegc",
                    "GuPJZhdoaWpCqmh",
                    "GYDBbRcVCixZp",
                    "gFeNVWfDfDQB",
                    "PoGaumWvIMOMpJCFanW",
                  ],
                  displayNumber: 3945293085571967,
                },
                valuationFrequency: {
                  attribute: {
                    valuationFrequency: "WEEKLY",
                  },
                  footnotes: [
                    "qqDsVtzBODmgWPbQEAaO",
                    "LaPbmnizoZED",
                    "vgNrNtZiaEXH",
                    "CVaiQUKZeC",
                    "KPVscsIlQlaALsMwi",
                    "KuVCssgEEP",
                  ],
                  displayNumber: 2619200250994672,
                },
                customFields: undefined,
                globalFootnotes: undefined,
                redemptionScheduleFrequencyWithFootnotes: {
                  attribute: "MONTHLY",
                  footnotes: undefined,
                  displayNumber: 3012755846298560,
                },
                description: undefined,
                subscriptionScheduleFrequency: undefined,
              },
            },
            {
              shareClassId: "5073a941-c9d4-4a14-bad5-ca5e8a77d40e",
              code: "jJeweFbGJzjfqy",
              name: "aKLxrROZtVevywGiT",
              fundVehicleId: "8e0a68b3-3b83-477b-b099-be75151cc641",
              attributes: {
                name: undefined,
                lockUp: undefined,
                investorTypes: undefined,
                nonQualifiedMinimumInvestment: {
                  attribute: {
                    amount: 1,
                    currency: "RSD",
                  },
                  footnotes: [
                    "VextpZMuRzTnlmC",
                    "hZUHUWJATDgtx",
                    "ITNqLkvPFQnMkCwChsID",
                    "AXWssCepmlHtiUTS",
                  ],
                  displayNumber: 513252312792660,
                },
                nonQualifiedMinimumSubsequentInvestment: {
                  attribute: {
                    amount: 0.27,
                    currency: "JPY",
                  },
                  footnotes: undefined,
                  displayNumber: 495614253630806,
                },
                fees: {
                  managementFees: undefined,
                  incentiveFees: {
                    attribute: [
                      {
                        type: "ADMINISTRATION",
                        name: undefined,
                        structure: undefined,
                        paymentFrequency: "MONTHLY_IN_ADVANCE",
                        rate: undefined,
                        feeBasis: "NET",
                        applicablePeriod: "INVESTMENT_PERIOD",
                        additionalInformation: "kKOSgxXOgAVwRzfh",
                      },
                      {
                        type: undefined,
                        name: undefined,
                        structure: undefined,
                        paymentFrequency: undefined,
                        rate: undefined,
                        feeBasis: "NET",
                        applicablePeriod: "POST_INVESTMENT_PERIOD",
                        additionalInformation: undefined,
                      },
                      {
                        type: undefined,
                        name: undefined,
                        structure: undefined,
                        paymentFrequency: "ONCE_ON_SUBSCRIPTION",
                        rate: undefined,
                        feeBasis: "GROSS",
                        applicablePeriod: undefined,
                        additionalInformation: undefined,
                      },
                      {
                        type: undefined,
                        name: undefined,
                        structure: "TIERED_RATE",
                        paymentFrequency: "ONCE_ON_TRANSFER",
                        rate: undefined,
                        feeBasis: undefined,
                        applicablePeriod: "POST_INVESTMENT_PERIOD",
                        additionalInformation: "AWvxfHkeZohKQdf",
                      },
                      {
                        type: undefined,
                        name: "IAQCVzPvwSfDLNEx",
                        structure: "TIERED_RATE",
                        paymentFrequency: "ONCE_OFF",
                        rate: 0.23,
                        feeBasis: "NOT_APPLICABLE",
                        applicablePeriod: "INVESTMENT_PERIOD",
                        additionalInformation: undefined,
                      },
                      {
                        type: undefined,
                        name: "aEPnbPYdWsWHUOb",
                        structure: "TIERED_RATE",
                        paymentFrequency: undefined,
                        rate: 0.29,
                        feeBasis: undefined,
                        applicablePeriod: "INVESTMENT_PERIOD",
                        additionalInformation: undefined,
                      },
                      {
                        type: "ADMINISTRATION",
                        name: undefined,
                        structure: undefined,
                        paymentFrequency: undefined,
                        rate: 0,
                        feeBasis: "NOT_APPLICABLE",
                        applicablePeriod: undefined,
                        additionalInformation: "ymFnnPiarzKOIGIotGd",
                      },
                      {
                        type: undefined,
                        name: undefined,
                        structure: "TIERED_RATE",
                        paymentFrequency: undefined,
                        rate: 0.75,
                        feeBasis: "NET",
                        applicablePeriod: "INVESTMENT_PERIOD",
                        additionalInformation: "QCrFMsydFsw",
                      },
                      {
                        type: undefined,
                        name: "aGTOZhlCmbuonX",
                        structure: "SINGLE_RATE",
                        paymentFrequency: undefined,
                        rate: 0.13,
                        feeBasis: "NOT_APPLICABLE",
                        applicablePeriod: undefined,
                        additionalInformation: undefined,
                      },
                      {
                        type: "PASS_THROUGH",
                        name: undefined,
                        structure: undefined,
                        paymentFrequency: "ANNUALLY_IN_ARREARS",
                        rate: 0.41,
                        feeBasis: undefined,
                        applicablePeriod: undefined,
                        additionalInformation: "pcKMYneVnLdNgKBXbp",
                      },
                    ],
                    footnotes: [
                      "BgzuqOdHQVMoFhgH",
                      "dfDlFlgCSJQnUtSynnD",
                      "WormaKEQcW",
                      "VfMEseFbAFMZn",
                      "rMWYXTZtXNicl",
                      "GlMhQPYhVrvyGZFWnu",
                      "qYLyNyaCGZcAfhF",
                      "MAlzaSaaFYSn",
                      "GQswghDfkmxc",
                    ],
                    displayNumber: 8364755421169804,
                  },
                  additionalFees: {
                    attribute: [
                      {
                        type: "PASS_THROUGH",
                        name: undefined,
                        structure: undefined,
                        paymentFrequency: undefined,
                        rate: 0.06,
                        feeBasis: "NET",
                        applicablePeriod: undefined,
                        additionalInformation: "SagDYIthhsLbSWUVaY",
                      },
                      {
                        type: "SALES_LOAD",
                        name: undefined,
                        structure: undefined,
                        paymentFrequency: "ANNUALLY_IN_ARREARS",
                        rate: 0.24,
                        feeBasis: "NOT_APPLICABLE",
                        applicablePeriod: undefined,
                        additionalInformation: "aqRBPSxsxHtOVoYGTfnq",
                      },
                      {
                        type: undefined,
                        name: undefined,
                        structure: "TIERED_RATE",
                        paymentFrequency: "MONTHLY_IN_ARREARS",
                        rate: 0.52,
                        feeBasis: "NET",
                        applicablePeriod: undefined,
                        additionalInformation: undefined,
                      },
                      {
                        type: undefined,
                        name: "EFvtmrzmOKo",
                        structure: undefined,
                        paymentFrequency: "QUARTERLY_IN_ADVANCE",
                        rate: undefined,
                        feeBasis: undefined,
                        applicablePeriod: "INVESTMENT_PERIOD",
                        additionalInformation: undefined,
                      },
                      {
                        type: "PASS_THROUGH",
                        name: "NvVHDdLJHnX",
                        structure: undefined,
                        paymentFrequency: "AD_HOC",
                        rate: 0.94,
                        feeBasis: undefined,
                        applicablePeriod: undefined,
                        additionalInformation: "pUcCWSsjkAFbvRxiXnP",
                      },
                      {
                        type: "SERVICING",
                        name: "AlAzkZTUJiDQczu",
                        structure: undefined,
                        paymentFrequency: "AD_HOC",
                        rate: 0.61,
                        feeBasis: undefined,
                        applicablePeriod: undefined,
                        additionalInformation: "BKQIYQORowDySb",
                      },
                      {
                        type: "SALES_LOAD",
                        name: "sNDXlTomzdts",
                        structure: "TIERED_RATE",
                        paymentFrequency: undefined,
                        rate: undefined,
                        feeBasis: undefined,
                        applicablePeriod: undefined,
                        additionalInformation: undefined,
                      },
                    ],
                    footnotes: [
                      "hArsHUDJICqtqV",
                      "EVUWlLFMnKvRPkjLCCN",
                      "mCRTofmXyvacIEDfsQj",
                      "giyXrIEhmWjKYgullgH",
                      "JWhqrmhzRXgQQufZIZ",
                      "umZnbAtnGsubEgl",
                      "qiEloGMMzxOkhIvKn",
                      "UvEfjbwZTGSEt",
                    ],
                    displayNumber: 5882140140092234,
                  },
                  generalPartnerCommitment: {
                    attribute: {
                      value: undefined,
                    },
                    footnotes: ["CnApAoYzMKzm", "JxearhVjuLQyjov"],
                    displayNumber: 3140564998527017,
                  },
                  catchUp: undefined,
                  carriedInterestRate: undefined,
                  hurdleRate: {
                    attribute: {
                      value: 0.26,
                    },
                    footnotes: undefined,
                    displayNumber: 7246592878485168,
                  },
                },
                dividendTreatment: undefined,
                distributionSchedule: {
                  attribute: {
                    distributionSchedule: "FORTNIGHTLY",
                  },
                  footnotes: undefined,
                  displayNumber: 4662618864931687,
                },
                subscriptionSchedule: undefined,
                redemptionSchedule: undefined,
                inceptionDate: {
                  attribute: "2025-01-01T10:00:00Z",
                  footnotes: undefined,
                  displayNumber: 5693050659768093,
                },
                redemptionGates: undefined,
                investorTargetRegion: {
                  attribute: [
                    "HKzESqBaJkzkbzw",
                    "kXaUMiyZHgxyPV",
                    "qpZDTwLoVx",
                    "nKvbvChjyrwxhjSiIv",
                    "dRzanvqsVsvNPeKzgncs",
                    "tEMFJTTShnAs",
                    "oYsvaLvfYOL",
                    "vLkKagwayBGfjFIbCOdv",
                  ],
                  footnotes: undefined,
                  displayNumber: 5152215345868410,
                },
                valuationFrequency: {
                  attribute: {
                    valuationFrequency: "FORTNIGHTLY",
                  },
                  footnotes: [
                    "cZkvcEzICuMbCfwPhWUv",
                    "PTjVVyPxDq",
                    "MaESlrEmStE",
                    "cjcyEcezPGfU",
                    "qGzWAXkrOOMSKHxyvGvh",
                  ],
                  displayNumber: 8326905988604465,
                },
                customFields: {
                  loanProgramEligible: true,
                },
                globalFootnotes: [
                  {
                    displayNumber: 1057871967963707,
                    footnotes: ["NfIFLyoItlvNypRTwt", "dJOujbHnyujAxGnl"],
                  },
                  {
                    displayNumber: 7334968215340504,
                    footnotes: [
                      "glDSURcQUcvBmAUTWz",
                      "IvcLocbWnxXyeC",
                      "eSpJAlAdsB",
                      "IczLwTGXoWFM",
                      "CSCFxhCYOMHsilaJQne",
                      "pxnrVrOGrQEad",
                      "xvhiPRDpWGPaxTrLIh",
                      "fLZXPBJLafFaVznuSW",
                    ],
                  },
                  {
                    displayNumber: 1046951629530151,
                    footnotes: [
                      "EOlBqefhFfDEVGZb",
                      "bLuFqiLVjVhMXhwru",
                      "IYjCxVaZyGsSDIHsdQ",
                      "SFsEHKQiXvSlb",
                      "qZfcclEAsemjMOOY",
                      "zvVFpDZSoXZmUTcIpJV",
                      "vVYdVerNOLcgWee",
                      "HsiTZcCnRrLCCSyRsjx",
                    ],
                  },
                  {
                    displayNumber: 4488789822614979,
                    footnotes: [
                      "DUAlgTcgdwBbAuORJy",
                      "SrsVYUZTKpXT",
                      "zdXDmpYGvzfd",
                      "AsDdXpdiejvMowWp",
                      "ijxmUcFFdMyLRqznka",
                    ],
                  },
                  {
                    displayNumber: 8679621037450446,
                    footnotes: [
                      "aoatdcIVvR",
                      "OdRTOQDnHw",
                      "yHaGHiwYTv",
                      "gbpWXQshEHwJM",
                      "APbJmoekZvWikDsHvQ",
                    ],
                  },
                ],
                redemptionScheduleFrequencyWithFootnotes: {
                  attribute: "QUARTERLY",
                  footnotes: [
                    "uoFXgPCBYFRAmKWRk",
                    "ADklNLRWqSIXo",
                    "KWQLuLPNJcIy",
                    "FFZeoIqrUEfqdCjSEdpG",
                    "AVsrQqejXWlCh",
                    "jcQqfRNJVzgdqeBax",
                    "tJsrZLAEGbe",
                    "scpgVkhGBDwyOluXj",
                  ],
                  displayNumber: 1725481457661798,
                },
                description: {
                  attribute: undefined,
                  footnotes: [
                    "MpyfjdDGVCndUyMaz",
                    "bOArPxaXnRQiy",
                    "sMmgABJNKR",
                  ],
                  displayNumber: 5132002611897424,
                },
                subscriptionScheduleFrequency: {
                  attribute: "AD_HOC",
                  footnotes: undefined,
                  displayNumber: 4694472333730508,
                },
              },
            },
          ],
        },
      ],
      globalFootnotes: undefined,
    },
    meta: undefined,
    errors: undefined,
  },
  ...overrideResponse,
});
